import axios from './network';

export default {
  getInters(){
    return axios.get("/inters");
  }
}